import { Component, inject } from '@angular/core';
import { PageTitleComponent } from '../../../../components/page-title/page-title.component';
import { TranslatePipe } from '@ngx-translate/core';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { HomeApiClientService } from '../../../../api/v1';
import { DocumentActionService } from '../../../../services/document-action.service';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.page.html',
  imports: [PageTitleComponent, TranslatePipe, NzButtonModule],
})
export class FAQPage {
  private homeApiClientService: HomeApiClientService = inject(HomeApiClientService);
  private documentActionService: DocumentActionService = inject(DocumentActionService);

  public openFAQDocument() {
    this.homeApiClientService.homeApiReadFrequentlyAskedQuestions().subscribe((data: Blob) => {
      this.documentActionService.openDocument(data);
    })
  }
}
